import React from 'react';
import { Radar } from 'react-chartjs-2';
import { Chart, RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend } from 'chart.js';
import { Evaluation } from '../../../App/API/Experiments';
import { title } from 'process';
import { useTranslation } from 'react-i18next';

Chart.register(RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend);

type ShowStudentEvaluationGraphProps = {
    evaluation: Evaluation;
};

export default function StudentEvaluationGraph({ evaluation }: ShowStudentEvaluationGraphProps): JSX.Element {
    const { t, i18n } = useTranslation();
    const [labels, setLabels] = React.useState<string[]>([]);

    React.useEffect(() => {
            setLabels(
                evaluation.map(item =>
                    t('evaluation_labels.' + item.name) +
                    ` (${((item.values.score / item.values.maxScore) * 10).toFixed(1)}/10)`
                )
            );
    }, [t]);

    const data = evaluation.map(item => (item.values.score / item.values.maxScore) * 10);

    const chartData = {
        labels,
        datasets: [
            {
                label: 'Score',
                data,
                backgroundColor: 'rgba(34, 202, 236, 0.2)',
                borderColor: 'rgba(34, 202, 236, 1)',
                pointBackgroundColor: 'rgba(34, 202, 236, 1)',
            },
        ],
    };

    const options = {
        scales: {
            r: {
                min: 0,
                max: 10,
                ticks: {
                    display: false,
                },
                pointLabels: {
                    font: {
                        size: 14,
                        weight: 'bold' as const,
                    },
                    color: '#fff',
                },
                angleLines: {
                    color: '#888',
                },
                grid: {
                    color: '#444',
                },
            },
        },
        plugins: {
            legend: {
                display: false
            },
        },
        maintainAspectRatio: false,
    };
    return (
        <>
            {labels && <Radar data={chartData} options={options} width={400} height={400} />}
        </>
    );
}